import * as AuthApi from '@/api/auth';

const state = {
  userId: '',
  userNm: '',
  userIp: '',
  idtAuthCd: '',
  idtAuthNm: '',
  idtType: '',
  deptCd: '',
  deptNm: '',
  accsssDt: '',
  lstConnDtt: '',
  lstConnIp: '',
  loginState: '',
};

const mutations = {
  SET_USER_ID(state, value) {
    state.userId = value;
  },
  SET_USER_NM(state, value) {
    state.userNm = value;
  },
  SET_USER_IP(state, value) {
    state.userIp = value;
  },
  SET_IDT_AUTH_CD(state, value) {
    state.idtAuthCd = value;
  },
  SET_IDT_AUTH_NM(state, value) {
    state.idtAuthNm = value;
  },
  SET_IDT_TYPE(state, value) {
    state.idtType = value;
  },
  SET_DEPT_CD(state, value) {
    state.deptCd = value;
  },
  SET_DEPT_NM(state, value) {
    state.deptNm = value;
  },
  SET_ACCSSS_DT(state, value) {
    state.accsssDt = value;
  },
  SET_LST_CONN_DTT(state, value) {
    state.lstConnDtt = value;
  },
  SET_LST_CONN_IP(state, value) {
    state.lstConnIp = value;
  },
  SET_LOGIN_STATE(state, value) {
    state.loginState = value;
  },
};

const actions = {
  checkSSOState(){
    return AuthApi.checkSSOState().then((e) => {
      if(e && e.status === 200){
        if(e.data.resultCode === 0){
          return Promise.resolve();
        }
      }
      return Promise.reject(e);
    });
  },
  getSSOUserInfo({ dispatch }){
    return AuthApi.loadCurrentUserInfo().then((e) => {
      if(e && e.status === 200){
        dispatch('setUserInfo', e.data);
        return Promise.resolve();
      }
      dispatch('setUserInfo', {});
      return Promise.reject(e);
    });
  },
  getLoginInfo({ dispatch, state }, loginInfo){
    return AuthApi.loginInfo(loginInfo.userId, loginInfo.password).then((e) => {
      if( e.status === 200 ){
        dispatch('setUserInfo', e.data);
        const loginState = state.loginState;
        if(loginState === "0"){
          return Promise.resolve();
        } else {
          return Promise.reject(e);
        }
      }
      dispatch('setUserInfo', {});
      return Promise.reject(e);
    })
  },
  setUserInfo({ commit }, userInfo) {
    commit('SET_USER_ID', userInfo.USER_ID);
    commit('SET_USER_NM', userInfo.USER_NM);
    commit('SET_USER_IP', userInfo.USER_IP);
    commit('SET_IDT_AUTH_CD', userInfo.IDT_AUTH_CD);
    commit('SET_IDT_AUTH_NM', userInfo.IDT_AUTH_NM);
    commit('SET_IDT_TYPE', userInfo.IDT_TYPE);
    commit('SET_DEPT_CD', userInfo.DEPT_CD);
    commit('SET_DEPT_NM', userInfo.DEPT_NM);
    commit('SET_ACCSSS_DT', userInfo.ACCESS_DT);
    commit('SET_LST_CONN_DTT', userInfo.LST_CONN_DTT);
    commit('SET_LST_CONN_IP', userInfo.LST_CONN_IP);
    commit('SET_LOGIN_STATE', userInfo.LOGIN_ERR_CODE);
  },
};

const getters = {
  userId: (state) => state.userId,
  userNm: (state) => state.userNm,
  userIp: (state) => state.userIp,
  idtAuthCd: (state) => state.idtAuthCd,
  idtAuthNm: (state) => state.idtAuthNm,
  idtType: (state) => state.idtType,
  deptCd: (state) => state.deptCd,
  deptNm: (state) => state.deptNm,
  accsssDt: (state) => state.accsssDt,
  lstConnDtt: (state) => state.lstConnDtt,
  lstConnIp: (state) => state.lstConnIp,
  loginState: (state) => state.loginState,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
